<template>
  <v-dialog
    :model-value="props.showModal"
    @update:model-value="props.handleToggle"
    :content-class="contentClass"
    :style="style"
    absolute
    attach=".app-template"
    :scrim="false"
  >
    <!-- <div class="modal-bottom" :class="{ 'modal-bottom--mobile': isMobile }" > -->
    <div class="modal-bottom__background" @keydown.esc="handleToggle" @click="handleToggle" />
    <div
      class="modal-bottom__body"
      :class="{ 'modal-bottom__body--no-height': props.noHeight }"
      :style="{ bottom }"
      ref="modalBody"
    >
      <div v-if="isMobile" class="modal-bottom__control" ref="modalActivator">
        <div class="modal-bottom__control__inner"></div>
      </div>
      <div
        class="modal-bottom__header d-flex align-start"
        :class="{ 'modal-bottom__header--no-subtitle': $slots.subtitle }"
      >
        <div v-if="props.title" class="modal-bottom__title">{{ props.title }}</div>
        <v-spacer />
        <ai-clear-button @click="handleToggle" class="modal-bottom__close">
          <inline-svg v-if="isMobile" :src="require('@/assets/icons/IconCloseMobile.svg')" />
          <inline-svg v-else :src="require('@/assets/icons/IconClose.svg')" />
        </ai-clear-button>
      </div>
      <div class="modal-bottom__header d-flex align-start">
        <slot name="subtitle" />
      </div>
      <div class="modal-bottom__content">
        <slot />
      </div>
    </div>
  </v-dialog>
</template>

<script lang="ts" setup>
import { PropType, computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useSwipe } from '@vueuse/core';

import { TFunction } from '@/types/TFunction';

import { useCommonStore } from '@/store/common';

import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';

const props = defineProps({
  showModal: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  handleToggle: {
    type: Function as PropType<TFunction>,
    required: true,
  },
  title: {
    type: String as PropType<string>,
    required: false,
  },
  background: {
    type: String as PropType<string>,
    required: false,
  },
  noHeight: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
});

const { isMobile } = storeToRefs(useCommonStore());

const modalActivator = ref<HTMLElement | null>(null);
const modalBody = ref<HTMLElement | null>(null);
const bottom = ref('0');

const containerHeight = computed(() => modalBody.value?.offsetHeight);
const contentClass = computed(() => {
  const classes = ['modal-bottom'];
  if (isMobile.value) {
    classes.push('modal-bottom--mobile');
  }
  return classes.join(' ');
});
const style = computed(() => {
  const result: any = {};
  if (props.background) {
    result.background = `${props.background}`;
  }
  return result;
});

const { lengthY } = useSwipe(modalActivator, {
  onSwipe() {
    bottom.value = lengthY.value < 0 ? `${lengthY.value}px` : '0';
  },
  onSwipeEnd() {
    if (lengthY.value < 0 && containerHeight.value && Math.abs(lengthY.value) / containerHeight.value >= 0.3) {
      bottom.value = '-100%';
      // infoShow.value = false;
      props.handleToggle(props.showModal);
    } else {
      bottom.value = '0';
    }
  },
});

watch(
  () => props.showModal,
  () => {
    bottom.value = '0';
  },
);
</script>

<style lang="scss" scoped src="./AiBottomModal.scss"></style>
